import instance from "./instance";
;



export const signup = async (data) =>{
    return instance.post("/v1/authentication/signup",data);
};

export const login = async (data) =>{
    return instance.post("/v1/authentication/login",data);
}

export const getProfileInformation = async () =>{
    return instance.get("/v1/users/profile");
}

export const getAllUsers = async () =>{
    return instance.get("/v1/users");
};

export const updateUserBus = async (data) =>{
    return instance.put('/v1/users',data)
}

export const getTransactions = async () =>{
    return instance.get('/v1/users/transactions')
}


export const getRequests = async () =>{
    return instance.get("/v1/requests");
}
export const getMyRequests = async () =>{
    return instance.get("/v1/requests/myRequests");
}

export const addRequest = async (data) =>{
    return instance.post("/v1/requests",data);
}

export const deleteRequest = async (id) =>{
    return instance.delete("/v1/requests/"+id);
}


export const addOffer = async (data) =>{
    return instance.post("/v1/offers",data);
}


export const acceptOffer = async (id) =>{
    return instance.post("/v1/offers/accept",{id});
}

export const deleteOffer = async (id) =>{
    return instance.delete(`/v1/offers/${id}`);
}


export const getMeters = async () =>{
    return instance.get("v1/users/meter");
}

export const addMeter = async (data) =>{
    return instance.post("v1/users/meter",data);
}

export const deleteMeter = async (id) =>{
    return instance.delete("v1/users/meter/"+id);
}

export const pauseRequest = async (id) =>{
    return instance.put("/v1/requests/pause",{id});
}

export const resumeRequest = async (id) =>{
    return instance.put("/v1/requests/resume",{id});
}

export const getAllTransactions = async () =>{
    return instance.get("/v1/users/transactions");
}